import { render } from "./UiTimePicker.vue?vue&type=template&id=f22c1c98&scoped=true"
import script from "./UiTimePicker.vue?vue&type=script&lang=js"
export * from "./UiTimePicker.vue?vue&type=script&lang=js"

import "./UiTimePicker.vue?vue&type=style&index=0&id=f22c1c98&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22c1c98"]])

export default __exports__